//NPM LIBRARIES
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import AUtextInput from '@gov.au/text-inputs';
import { AUlabel, AUformGroup } from '@gov.au/form';
import CheckboxOption from '../CheckboxOption';
import { AUcallout } from '@gov.au/callout';


//COMPONENTS AND UTILITIES
import { validateAnswerHasValue } from '../../CASAForm/Utilities';

export default class TextCheckboxEnabled extends Component {

    constructor(props) {
        super(props);

        let answer = {
            value: '',
            checkboxes: {},
            checked: false
        };

        let errorMessage = ''

        if (props.existingAnswer) {
            answer = props.existingAnswer
        } 

        if (props.mandatory) {
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);
        }

        if (this.props.validate) {
            errorMessage = this.props.validate(answer)
        }

        this.state = {
            answer: answer,
            errorMessage: errorMessage,
            noSerialNumber: false,
            enableSerialNumber: true,
            showNoSerial: false
        }
    }

    onBlur = (e) => {    
        let errorMessage = null

        if (this.props.validate) {
            errorMessage = this.props.validate(this.state.answer)
        }

        this.setState({ errorMessage: errorMessage });

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: this.state.answer 
        }

        if (this.props.onChange) {
            this.props.onChange(questionObject)
        }

        this.props.returnQuestionData(questionObject);
    };

    onChange = (e) => {
        this.setState({ 'answer': { value: e.target.value, checked: this.state.answer.checked } });

        if (this.props.onChange) {
            this.props.onChange(this.props.id, { value: e.target.value, checked: this.state.answer.checked })
        }
   }

    renderHintText = () => {
        return { __html: '<span className="au-hint-text">' + this.props.hintText + '</span>' };
    }

    renderErrorText = (errorMessage) => {
        return { __html: '<span id=' + this.props.id + '-error class="au-error-text">' + errorMessage + '</span>' };
    }

    createErrorMessage = (errorMessage) => {
        if (this.props.showError && errorMessage) {
            return (
                <div dangerouslySetInnerHTML = { this.renderErrorText(errorMessage)} />
            );
        }
    }

    //this needs to be moved to dronerego or made generic
    getCheckboxValue = (checkboxValue) => {
        if (checkboxValue.questionid === 'noSerial') {
            if (checkboxValue.check) { 
                let errorMessage = null
                if (this.props.validate) {
                    errorMessage = this.props.validate({ value: '', checked: true })
                }
                this.setState({
                    answer: { value: '', checked: true},
                    noSerialNumber: true,
                    showNoSerial: true,
                    errorMessage: errorMessage,
                    enableSerial: false
                })
                if (this.props.onChange) {
                    this.props.onChange(this.props.id, { value: '', checked: true })
                }
            } else {
                let errorMessage = null
                if (this.props.validate) {
                    errorMessage = this.props.validate({ value: this.state.answer.value, checked: false })
                }
               this.setState({
                    answer: { value: this.state.answer.value, checked: false },
                    noSerialNumber: false,
                    showNoSerial: false,
                    errorMessage: errorMessage,
                    enableSerial: true
               })
                if (this.props.onChange) {
                    this.props.onChange(this.props.id, { value: this.state.answer.value, checked: false })
                }

            }


        }
    }

    render() {
        return (    
            <AUformGroup
                status={this.props.getStatus(this.state.errorMessage)}>

                <AUlabel text={this.props.label} htmlFor={this.props.id} />

                {this.props.hintText &&
                    <div dangerouslySetInnerHTML={this.renderHintText()} />
                }

                <AUtextInput
                    type="text"
                    id={this.props.id}
                    name={this.props.id}
                    aria-describedby={`${this.props.id}-error`}
                    status={this.props.getStatus(this.state.errorMessage)}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    value={this.state.answer.value ? this.state.answer.value : ""}
                    block
                    placeholder={this.props.placeholder}
                    disabled={!this.state.enableSerial} />

                <br />

                <CheckboxOption
                    type="checkbox"
                    name="noSerialNumber"
                    id="noSerialNumber"
                    questionid="noSerial"
                    value="noSerialNumber" 
                    optionLabel="No serial number available"
                    checked={this.state.answer.checked}
                    key="noSerialNumber"
                    onBlur={this.onBlur}
                    onChangeFunction={this.getCheckboxValue}>
                </CheckboxOption>

                { this.state.showNoSerial ?
                    <AUcallout
                        title=""
                        srOnlyTitle
                        style={{ maxWidth: `34.5em` }}>
                        <p>If your drone doesn&apos;t have a serial number, you will receive a registration mark that will be recorded on the certificate of registration. The CASA-assigned registration mark must always be legibly displayed on the RPA when operating.</p>
                    </AUcallout>
                    : <Fragment />
                }

                {this.createErrorMessage(this.state.errorMessage)}

            </AUformGroup>
        );
    }
}

TextCheckboxEnabled.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    validate: PropTypes.func,
    mandatory: PropTypes.bool,
    enabled: PropTypes.bool,
    show: PropTypes.bool,
    type: PropTypes.string,
    hintText: PropTypes.string,
    placeholder: PropTypes.string,
    existingAnswer: PropTypes.object,
    onChange: PropTypes.func,
    returnQuestionData: PropTypes.func,
    getStatus: PropTypes.func,
    createErrorMessage: PropTypes.func,
    numpattern: PropTypes.string,
    showError: PropTypes.bool,
    disabled: PropTypes.bool
};


